module.exports = __webpack_public_path__ + "static/media/shawinder-jit-singh.65d3ae77.jpg";